import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Checkbox,
  Segment,
  Label,
  Dropdown,
  FormGroup,
  FormField,
  Form,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const ModWaitingListManageUX = (props: any) => {
    return(
      <div
        id="ModWaitingListManageUX-div-0">
        
        <Segment
          id="ModWaitingListManageUX-Segment-20">
          <Label
            color="blue"
            id="ModWaitingListManageUX-Label-21"
            ribbon={true}
            style={{fontSize: "1.2rem", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Manage Waiting List Patients" : "จัดการรายชื่อผู้ป่วย Waiting List"}
          </Label>
          <Label
            id="ModWaitingListManageUX-Label-35"
            size="big">
            {props.waitingListName}
          </Label>
          <Label
            id="ModWaitingListManageUX-Label-85"
            size="big"
            style={{float: "right", backgroundColor: "#5dbcd2", color: "white"}}>
            {props.divisionName || ""}
          </Label>
          <div
            id="ModWaitingListManageUX-div-4"
            style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 0px 10px 0px"}}>
            
            <div
              id="ModWaitingListManageUX-div-22"
              style={{display: props.isHiddenGroup ? "none": "flex", flexDirection: "column", width: "100%", padding: "0px 5px"}}>
              
              <div
                id="ModWaitingListManageUX-div-101">
                {props.languageUX === "en" ? "Name-Surname / HN" : "ชื่อ-สกุล / HN"}
              </div>
              <div
                id="ModWaitingListManageUX-div-93"
                style={{display: "flex", alignItems: "center",}}>
                
                <div
                  id="ModWaitingListManageUX-div-94"
                  style={{margin: "10px 0px"}}>
                  {props.patientSelector}
                </div>
                <div
                  id="ModWaitingListManageUX-div-95"
                  style={{display: !props.manageWaitingListPatient?"none":"grid", backgroundColor: "#dff6fb", padding: "0.75rem 1rem", margin: "0 0.5rem 0 1rem", borderRadius: "3px", width: "100%", gridTemplateColumns: "repeat(4,1fr)"}}>
                  
                  <div
                    id="ModWaitingListManageUX-div-113">
                    
                    <label
                      id="ModWaitingListManageUX-label-115"
                      style={{fontWeight: "bold", marginRight: "1rem"}}>
                      HN: 
                    </label>
                    <label
                      id="ModWaitingListManageUX-label-114">
                      {props.manageWaitingListPatient?.hn || "-"}
                    </label>
                  </div>
                  <div
                    id="ModWaitingListManageUX-div-102">
                    
                    <label
                      id="ModWaitingListManageUX-label-105"
                      style={{marginLeft: "0.5rem"}}>
                      {props.manageWaitingListPatient?.full_name||"-"}
                    </label>
                  </div>
                  <div
                    id="ModWaitingListManageUX-div-103">
                    
                    <label
                      id="ModWaitingListManageUX-label-106"
                      style={{fontWeight: "bold", marginRight: "1rem"}}>
                      {props.languageUX === "en" ? "ID/Passport" : "บัตรประจำตัวประชาชน/หนังสือเดินทาง"}
                    </label>
                    <label
                      id="ModWaitingListManageUX-label-107">
                      {props.manageWaitingListPatient?.citizen_passport||"-"}
                    </label>
                  </div>
                  <div
                    id="ModWaitingListManageUX-div-104">
                    
                    <label
                      id="ModWaitingListManageUX-label-108"
                      style={{fontWeight: "bold", marginRight: "1rem"}}>
                      {props.languageUX === "en" ? "Date of birth" : "วันเดือนปีเกิด"}
                    </label>
                    <label
                      id="ModWaitingListManageUX-label-109">
                      {props.manageWaitingListPatient?.birthdate||"-"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="ModWaitingListManageUX-div-15"
              style={{display: props.isHiddenGroup ? "none": "none", flexDirection: "column", width: "30%",padding: "0px 5px"}}>
              {props.languageUX === "en" ? "Dentist / Student" : "ทันตแพทย์ / นิสิต"}
              <div
                id="ModWaitingListManageUX-div-23"
                style={{width: "100%", margin: "10px 0px"}}>
                {props.doctorSelector}
              </div>
            </div>
            <div
              id="ModWaitingListManageUX-div-24"
              style={{flex:1}}>
              
            </div>
            <div
              id="ModWaitingListManageUX-div-25"
              style={{display: "flex", flexDirection: "column", alignSelf: "flex-end",paddingBottom: "12px"}}>
              {}
              <Button
                color="green"
                disabled={props.disableAddPatient}
                id="ModWaitingListManageUX-Button-5"
                onClick={props.addPatientToWaitingList}
                size="small"
                style={{...(props.isHiddenGroup && {display: "none"}), minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Add patient to list" : "เพิ่มผู้ป่วยเข้า List"}
              </Button>
            </div>
            <div
              id="ModWaitingListManageUX-div-26"
              style={{display: "flex", flexDirection: "column",alignSelf: "flex-end",paddingBottom: "12px"}}>
              
              <Button
                color="blue"
                disabled={props.disabledPrint}
                id="ModWaitingListManageUX-Button-14"
                onClick={props.printWaitingList}
                size="small"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Print all items" : "พิมพ์รายการทั้งหมด"}
              </Button>
            </div>
          </div>
          <div
            id="ModWaitingListManageUX-div-60">
            {props.divider}
          </div>
          <div
            id="ModWaitingListManageUX-div-8"
            style={{display: "none", justifyContent: "flex-start", alignItems: "center", padding: "10px 10px"}}>
            
            <Checkbox
              checked={props.isAppointed}
              id="ModWaitingListManageUX-Checkbox-9"
              label={props.languageUX === "en" ? "Show a list of patients with appointments" : "แสดงรายชื่อผู้ป่วยที่มีนัดหมายแล้ว"}
              onClick={props.toggleIsAppointed}
              style={{marginRight: "30px"}}>
            </Checkbox>
            <Checkbox
              checked={props.isOnHoldQ}
              id="ModWaitingListManageUX-Checkbox-27"
              label={props.languageUX === "en" ? "Show a list of patients in queue" : "แสดงรายชื่อผู้ป่วยที่พักคิว"}
              onClick={props.toggleIsOnHoldQ}
              style={{marginRight: "30px",}}>
            </Checkbox>
          </div>
          <div
            id="ModWaitingListManageUX-div-43"
            style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginTop: "2px"}}>
            
            <Form
              id="ModWaitingListManageUX-Form-49">
              <FormGroup
                id="ModWaitingListManageUX-FormGroup-44"
                inline={true}>
                <FormField
                  id="ModWaitingListManageUX-FormField-70"
                  style={{display: "flex", alignItems: "center"}}>
                  <label
                    id="ModWaitingListManageUX-label-71">
                    {props.languageUX === "en" ? "HN" : "เอชเอ็น"}
                  </label>
                  <Input
                    id="ModWaitingListManageUX-Input-72"
                    onChange={props.onChangeHN}
                    value={props.hn}>
                  </Input>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-73"
                  style={{display: "flex", alignItems: "center"}}>
                  <label
                    id="ModWaitingListManageUX-label-74"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Queue number" : "เลขที่คิว"}
                  </label>
                  <Input
                    id="ModWaitingListManageUX-Input-75"
                    onChange={props.onChangeQueueNumber}
                    value={props.queueNumber}>
                  </Input>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-45"
                  style={{display: "flex", alignItems: "center"}}>
                  <label
                    id="ModWaitingListManageUX-label-53"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Queuing date" : "วันที่เข้าคิว"}
                  </label>
                  <DateTextBox
                    id="ModWaitingListManageUX-DateTextBox-47"
                    onChange={props.onChangeStartDate}
                    value={props.startDate}>
                  </DateTextBox>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-50"
                  style={{display: "flex", alignItems: "center"}}>
                  <label
                    id="ModWaitingListManageUX-label-54">
                    {props.languageUX === "en" ? "to" : "ถึง"}
                  </label>
                  <DateTextBox
                    id="ModWaitingListManageUX-DateTextBox-52"
                    onChange={props.onChangeEndDate}
                    value={props.endDate}>
                  </DateTextBox>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-55"
                  style={{display:"flex",alignItems:"center"}}>
                  <label
                    id="ModWaitingListManageUX-label-56">
                    {props.languageUX === "en" ? "status" : "สถานะ"}
                  </label>
                  <Dropdown
                    clearable={true}
                    id="ModWaitingListManageUX-Dropdown-57"
                    multiple={true}
                    onChange={props.onChangeFilterStatus}
                    options={props.statusOptions}
                    selection={true}
                    style={{minWidth: "250px"}}
                    value={props.filterStatus}>
                  </Dropdown>
                </FormField>
              </FormGroup>
              <FormGroup
                id="ModWaitingListManageUX-FormGroup-69"
                inline={true}>
                <FormField
                  id="ModWaitingListManageUX-FormField-83">
                  <label
                    id="ModWaitingListManageUX-label-84">
                    {props.languageUX === "en" ? "Select a doctor" : "เลือกแพทย์"}
                  </label>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-59"
                  inline={true}>
                  <div
                    id="ModWaitingListManageUX-div-39"
                    style={{display: "flex",alignItems:"center",width:"250px"}}>
                    {props.doctorFilters}
                  </div>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-63">
                  <Checkbox
                    checked={props.noDoctorFilters}
                    id="ModWaitingListManageUX-Checkbox-65"
                    label={props.languageUX === "en" ? "Show only unspecified doctors" : "แสดงเฉพาะไม่กำหนดแพทย์"}
                    onChange={props.onChangeNoDoctorFilters}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-77"
                  style={{marginLeft:"20px"}}>
                  <label
                    id="ModWaitingListManageUX-label-79">
                    วันที่ Complete case 
                  </label>
                  <DateTextBox
                    id="ModWaitingListManageUX-DateTextBox-81"
                    onChange={props.onChangeCompleteCaseStart}
                    value={props.completeCaseStart}>
                  </DateTextBox>
                </FormField>
                <FormField
                  id="ModWaitingListManageUX-FormField-78">
                  <label
                    id="ModWaitingListManageUX-label-80">
                    {props.languageUX === "en" ? "to" : "ถึง"}
                  </label>
                  <DateTextBox
                    id="ModWaitingListManageUX-DateTextBox-82"
                    onChange={props.onChangeCompleteCaseEnd}
                    value={props.completeCaseEnd}>
                  </DateTextBox>
                </FormField>
              </FormGroup>
            </Form>
            <Button
              color="blue"
              id="ModWaitingListManageUX-Button-61"
              loading={props.waitingListItemLoading}
              onClick={props.onClickSearch}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <Table
            data={props.waitingListItems}
            getTrProps={props.getTrPropsWaitingList}
            headers={props.headers}
            id="ModWaitingListManageUX-Table-2"
            keys={props.keys}
            minRows="4"
            showPagination={false}
            style={{maxHeight: "50vh"}}
            widths={props.widths}>
          </Table>
          <div
            id="ModWaitingListManageUX-div-62">
            {props.pagination}
          </div>
          <div
            className="--override-disabled"
            id="ModWaitingListManageUX-div-12"
            style={{ marginTop:"15px", display: props.disableAssign ? "none" : "block" }}>
            
            <div
              id="ModWaitingListManageUX-div-30"
              style={{display: "flex", flexDirection:"row"}}>
              
              <div
                id="ModWaitingListManageUX-div-11"
                style={{width: "50%"}}>
                {props.providerSelector}
              </div>
              <div
                id="ModWaitingListManageUX-div-31"
                style={{display:"none", justifyContent: "center", alignItems:"center"}}>
                {props.languageUX === "en" ? "Appointment Type" : "ประเภทการนัดหมาย"}
                <Dropdown
                  id="ModWaitingListManageUX-Dropdown-29"
                  onChange={props.onChangeTreatmentType}
                  options={props.treatmentTypeOptions}
                  selection={true}
                  style={{marginLeft:"10px"}}
                  value={props.treatmentType}>
                </Dropdown>
              </div>
            </div>
            <div
              id="ModWaitingListManageUX-div-18"
              style={{margin:"20px 0px 10px 0px",fontWeight: "bold", display:"flex",justifyContent:"flex-start",gap:"100px",alignItems:"center"}}>
              {props.languageUX === "en" ? "Job details" : "รายละเอียดงาน"}
              <div
                id="ModWaitingListManageUX-div-68"
                style={{display:props.isDoctor?"none":"flex",justifyContent:"center",alignItems:"center",gap:"20px"}}>
                
                <label
                  id="ModWaitingListManageUX-label-67">
                  {props.languageUX === "en" ? "Complete Case Date" : "วันที่ Complete Case"}
                </label>
                <DateTextBox
                  disabled={props.isWaitingListReadonly || props.disabledMultiDetail}
                  id="ModWaitingListManageUX-DateTextBox-66"
                  onChange={props.onChangeCompleteCaseDate}
                  value={props.completeCaseDate}>
                </DateTextBox>
              </div>
            </div>
            <div
              className="ui form"
              id="ModWaitingListManageUX-div-110"
              style={{position: "relative"}}>
              
              <Dropdown
                allowAdditions={true}
                disabled={props.isWaitingListReadonly || props.disabledMultiDetail}
                fluid={true}
                id="ModWaitingListManageUX-Dropdown-116"
                multiple={true}
                onAddItem={props.onAddItem}
                onChange={props.changeNote}
                options={props.waitingListNoteOptions}
                search={true}
                selection={true}
                style={{width: "100%", margin :"0px 0px 20px 0px"}}
                value={props.note}>
              </Dropdown>
              <div
                id="ModWaitingListManageUX-div-112"
                style={{display: props.disabledMultiDetail?"flex":"none",opacity: 0.75, position: "absolute",alignItems: "center", height: "100%", top: "0rem", left: "1rem", color: "red"}}>
                {"ไม่สามารถแสดงรายละเอียดงาน กรณีเลือก เลขที่คิวมากกว่า 1 รายการ" }
              </div>
            </div>
            <div
              id="ModWaitingListManageUX-div-17"
              style={{display:props.isWaitingListReadonly?"none":"flex", flexDirection: "row"}}>
              
              <Button
                color="green"
                disabled={props.disableAssign || props.disabledMultiDetail || !props.buttonActions?.save}
                id="ModWaitingListManageUX-Button-13"
                onClick={props.assignWaitingListItems}
                size="tiny"
                style={{marginRight: "10px"}}>
                {props.languageUX === "en" ? "Save" : "บันทึก"}
              </Button>
              <Button
                color="orange"
                disabled={props.disabledPauseQ || !props.buttonActions?.stall}
                id="ModWaitingListManageUX-Button-32"
                onClick={props.onClickPauseQ}
                size="tiny"
                style={{marginRight: "10px", display: props.isDoctor?"none":""}}>
                {props.languageUX === "en" ? "Take a break" : "พักคิว"}
              </Button>
              <Button
                color="blue"
                disabled={props.disabledResumeQ || !props.buttonActions?.recall}
                id="ModWaitingListManageUX-Button-33"
                onClick={props.onClickResumeQ}
                size="tiny"
                style={{marginRight: "10px",display: props.isDoctor?"none":""}}>
                {props.languageUX === "en" ? "Return queue" : "คืนคิว"}
              </Button>
              <Button
                color="red"
                disabled={!props.buttonActions?.cancel}
                id="ModWaitingListManageUX-Button-34"
                onClick={props.onCancelTreatmentPlan}
                size="tiny"
                style={{marginRight: "10px",display: props.isDoctor?"none":""}}>
                {props.languageUX === "en" ? "Cancel treatment plan" : "ยกเลิกวางแผนการรักษา"}
              </Button>
              <Button
                disabled={!props.buttonActions?.sent}
                id="ModWaitingListManageUX-Button-38"
                onClick={props.onSendToClinic}
                size="tiny"
                style={{backgroundColor: "#5bbdd2", color: "white",display: props.isDoctor?"none":""}}>
                {props.languageUX === "en" ? "Refer to clinic" : "ส่งต่อคลินิก"}
              </Button>
            </div>
          </div>
          <div
            id="ModWaitingListManageUX-div-19"
            style={{padding: "10px",display:props.openModClinic ? "":"none"}}>
            {props.OpenClinic}
          </div>
        </Segment>
      </div>
    )
}


export default ModWaitingListManageUX

export const screenPropsDefault = {"patientSelector":"[Patient Selector]","providerSelector":"[Provider Selector]"}

/* Date Time : Wed Oct 01 2025 12:24:25 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-0"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 2,
      "name": "Table",
      "parent": 20,
      "props": {
        "data": {
          "type": "code",
          "value": "props.waitingListItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrPropsWaitingList"
        },
        "headers": {
          "type": "code",
          "value": "props.headers"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Table-2"
        },
        "keys": {
          "type": "code",
          "value": "props.keys"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{maxHeight: \"50vh\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.widths"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", padding: \"20px 0px 10px 0px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มผู้ป่วยเข้า List",
          "valueEN": "Add patient to list"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableAddPatient"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-5"
        },
        "onClick": {
          "type": "code",
          "value": "props.addPatientToWaitingList"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{...(props.isHiddenGroup && {display: \"none\"}), minWidth: \"max-content\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", justifyContent: \"flex-start\", alignItems: \"center\", padding: \"10px 10px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isAppointed"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Checkbox-9"
        },
        "label": {
          "type": "value",
          "value": "แสดงรายชื่อผู้ป่วยที่มีนัดหมายแล้ว",
          "valueEN": "Show a list of patients with appointments"
        },
        "onClick": {
          "type": "code",
          "value": "props.toggleIsAppointed"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"30px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "props.providerSelector"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{width: \"50%\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop:\"15px\", display: props.disableAssign ? \"none\" : \"block\" }"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableAssign || props.disabledMultiDetail || !props.buttonActions?.save"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "props.assignWaitingListItems"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์รายการทั้งหมด",
          "valueEN": "Print all items"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPrint"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": "props.printWaitingList"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ทันตแพทย์ / นิสิต",
          "valueEN": "Dentist / Student"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isHiddenGroup ? \"none\": \"none\", flexDirection: \"column\", width: \"30%\",padding: \"0px 5px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{display:props.isWaitingListReadonly?\"none\":\"flex\", flexDirection: \"row\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดงาน",
          "valueEN": "Job details"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"20px 0px 10px 0px\",fontWeight: \"bold\", display:\"flex\",justifyContent:\"flex-start\",gap:\"100px\",alignItems:\"center\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.OpenClinic"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\",display:props.openModClinic ? \"\":\"none\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Segment-20"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "จัดการรายชื่อผู้ป่วย Waiting List",
          "valueEN": "Manage Waiting List Patients"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Label-21"
        },
        "ribbon": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isHiddenGroup ? \"none\": \"flex\", flexDirection: \"column\", width: \"100%\", padding: \"0px 5px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSelector"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"10px 0px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\", alignSelf: \"flex-end\",paddingBottom: \"12px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection: \"column\",alignSelf: \"flex-end\",paddingBottom: \"12px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isOnHoldQ"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Checkbox-27"
        },
        "label": {
          "type": "value",
          "value": "แสดงรายชื่อผู้ป่วยที่พักคิว",
          "valueEN": "Show a list of patients in queue"
        },
        "onClick": {
          "type": "code",
          "value": "props.toggleIsOnHoldQ"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"30px\",}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Dropdown",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Dropdown-29"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTreatmentType"
        },
        "options": {
          "type": "code",
          "value": "props.treatmentTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.treatmentType"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection:\"row\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทการนัดหมาย",
          "valueEN": "Appointment Type"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display:\"none\", justifyContent: \"center\", alignItems:\"center\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "พักคิว",
          "valueEN": "Take a break"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPauseQ || !props.buttonActions?.stall"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-32"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickPauseQ"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", display: props.isDoctor?\"none\":\"\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "คืนคิว",
          "valueEN": "Return queue"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledResumeQ || !props.buttonActions?.recall"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-33"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickResumeQ"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\",display: props.isDoctor?\"none\":\"\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกวางแผนการรักษา",
          "valueEN": "Cancel treatment plan"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "!props.buttonActions?.cancel"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-34"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelTreatmentPlan"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\",display: props.isDoctor?\"none\":\"\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Label",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.waitingListName"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Label-35"
        },
        "size": {
          "type": "value",
          "value": "big"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งต่อคลินิก",
          "valueEN": "Refer to clinic"
        },
        "color": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "!props.buttonActions?.sent"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-38"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSendToClinic"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#5bbdd2\", color: \"white\",display: props.isDoctor?\"none\":\"\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorFilters"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",alignItems:\"center\",width:\"250px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"space-between\",alignItems:\"flex-start\",marginTop: \"2px\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormGroup",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormGroup-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 47,
      "name": "DateTextBox",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-DateTextBox-47"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Form",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Form-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 52,
      "name": "DateTextBox",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-DateTextBox-52"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เข้าคิว",
          "valueEN": "Queuing date"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-54"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",alignItems:\"center\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Dropdown",
      "parent": 55,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Dropdown-57"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterStatus"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"250px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterStatus"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divider"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-60"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Button-61"
        },
        "loading": {
          "type": "code",
          "value": "props.waitingListItemLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickSearch"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-62"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-63"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Checkbox",
      "parent": 63,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.noDoctorFilters"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Checkbox-65"
        },
        "label": {
          "type": "value",
          "value": "แสดงเฉพาะไม่กำหนดแพทย์",
          "valueEN": "Show only unspecified doctors"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNoDoctorFilters"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 66,
      "name": "DateTextBox",
      "parent": 68,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isWaitingListReadonly || props.disabledMultiDetail"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-DateTextBox-66"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCompleteCaseDate"
        },
        "value": {
          "type": "code",
          "value": "props.completeCaseDate"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ Complete Case",
          "valueEN": "Complete Case Date"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-67"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{display:props.isDoctor?\"none\":\"flex\",justifyContent:\"center\",alignItems:\"center\",gap:\"20px\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormGroup",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormGroup-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "เอชเอ็น",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Input",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Input-72"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeHN"
        },
        "value": {
          "type": "code",
          "value": "props.hn"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่คิว",
          "valueEN": "Queue number"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-74"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Input",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Input-75"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeQueueNumber"
        },
        "value": {
          "type": "code",
          "value": "props.queueNumber"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-77"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"20px\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-78"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ Complete case "
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-79"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 81,
      "name": "DateTextBox",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-DateTextBox-81"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCompleteCaseStart"
        },
        "value": {
          "type": "code",
          "value": "props.completeCaseStart"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 82,
      "name": "DateTextBox",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-DateTextBox-82"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCompleteCaseEnd"
        },
        "value": {
          "type": "code",
          "value": "props.completeCaseEnd"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-FormField-83"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกแพทย์",
          "valueEN": "Select a doctor"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-84"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Label",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionName || \"\""
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Label-85"
        },
        "size": {
          "type": "value",
          "value": "big"
        },
        "style": {
          "type": "code",
          "value": "{float: \"right\", backgroundColor: \"#5dbcd2\", color: \"white\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSelector"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px 0px\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.manageWaitingListPatient?\"none\":\"grid\", backgroundColor: \"#dff6fb\", padding: \"0.75rem 1rem\", margin: \"0 0.5rem 0 1rem\", borderRadius: \"3px\", width: \"100%\", gridTemplateColumns: \"repeat(4,1fr)\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุล / HN",
          "valueEN": "Name-Surname / HN"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-101"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-102"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-103"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-104"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "code",
          "value": "props.manageWaitingListPatient?.full_name||\"-\""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-105"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"0.5rem\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "บัตรประจำตัวประชาชน/หนังสือเดินทาง",
          "valueEN": "ID/Passport"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"1rem\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.manageWaitingListPatient?.citizen_passport||\"-\""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเดือนปีเกิด",
          "valueEN": "Date of birth"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-108"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"1rem\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.manageWaitingListPatient?.birthdate||\"-\""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "code",
          "value": "\"ไม่สามารถแสดงรายละเอียดงาน กรณีเลือก เลขที่คิวมากกว่า 1 รายการ\" "
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{display: props.disabledMultiDetail?\"flex\":\"none\",opacity: 0.75, position: \"absolute\",alignItems: \"center\", height: \"100%\", top: \"0rem\", left: \"1rem\", color: \"red\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-div-113"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.manageWaitingListPatient?.hn || \"-\""
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-114"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "HN: "
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-label-115"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"1rem\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Dropdown",
      "parent": 110,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isWaitingListReadonly || props.disabledMultiDetail"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModWaitingListManageUX-Dropdown-116"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddItem"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeNote"
        },
        "options": {
          "type": "code",
          "value": "props.waitingListNoteOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin :\"0px 0px 20px 0px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 112,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "ModWaitingListManageUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "patientSelector": "[Patient Selector]",
    "providerSelector": "[Provider Selector]"
  },
  "width": 40
}

*********************************************************************************** */
